import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class GoogleApiService {

	constructor(private http: HttpClient) { }

	getPlaces(searchKey): Observable<any> {
		return this.http.get('https://maps.googleapis.com/maps/api/place/queryautocomplete/json?key=AIzaSyBPR0k7lgPacXwdcuw62MBxa5iujLHqhNk&input=' + searchKey);
	}

	getDirections(origin, destination): Observable<any> {
		return this.http.get('https://maps.googleapis.com/maps/api/directions/json?origin=' + origin + '&destination=' + destination + '&key=AIzaSyBPR0k7lgPacXwdcuw62MBxa5iujLHqhNk');
	}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/services/googleapi.service.ts